<ng-select (change)="onSelectElement()" (scrollToEnd)="onGetMoreItems()" (search)="onSearch($event)"
    [(ngModel)]="college_id" placeholder="Choisissez collège " name="college_id" id="college_id"
    [multiple]="false" [closeOnSelect]="true">
    <ng-option *ngFor="let item of items" [value]="item.id">{{ item.libelle}}
    </ng-option>
</ng-select>